// Configuración "Simple": los selects de siempre (compañía, sucursal y sedes). La
// PRIMERA sede seleccionada es la primaria (TMUSE10.SedCod); todas se registran en
// el detalle TMUSE20. La compañía solo se elige al agregar, como antes.
import Select from 'react-select';
import { Aviso } from './SelectorConfiguracion';

// Sedes elegidas que pertenecen a otra sucursal de la compañía. Se permiten,
// como hasta hoy (el picker ofrece el árbol completo), pero se avisa.
const sedesDeOtraSucursal = (acc: any): number => {
    const sucursalDe = new Map((acc.listaSedes || []).map((s: any) => [`${s?.SedCod}`, `${s?.sucursal_cod ?? ""}`]))
    return (acc.simple.sedes || []).filter((s: any) => {
        const suc = sucursalDe.get(`${s?.value}`)
        return suc && acc.sucursal && suc !== `${acc.sucursal}`
    }).length
}

export const ConfiguracionSimple = ({ acc }: { acc: any }) => {
    const { simple } = acc
    const otras = sedesDeOtraSucursal(acc)
    return (
        <section className="tw-mt-4 tw-flex tw-flex-col tw-gap-3 tw-rounded-xl tw-border tw-border-gray-200 tw-bg-gray-50/60 tw-p-4">
            <div className="tw-flex tw-flex-col sm:tw-flex-row sm:tw-items-center tw-gap-1 sm:tw-gap-3">
                <label htmlFor="simple-compania" className="tw-m-0 tw-shrink-0 sm:tw-w-28 tw-text-sm tw-font-medium tw-text-gray-700">Compañía</label>
                <select id="simple-compania" className="form-select form-select-sm" value={acc.compania}
                    disabled={acc.accion !== "agregar"} onChange={(e) => simple.cambiarCompania(e.target.value)}>
                    {(acc.listaCompanias || []).map((c: any) => <option key={c?.id} value={c?.id}>{c?.tipo}</option>)}
                </select>
            </div>
            <div className="tw-flex tw-flex-col sm:tw-flex-row sm:tw-items-center tw-gap-1 sm:tw-gap-3">
                <label htmlFor="simple-sucursal" className="tw-m-0 tw-shrink-0 sm:tw-w-28 tw-text-sm tw-font-medium tw-text-gray-700">Sucursal</label>
                <select id="simple-sucursal" className="form-select form-select-sm" value={acc.sucursal}
                    onChange={(e) => simple.cambiarSucursal(e.target.value)}>
                    <option value="" disabled>Seleccione</option>
                    {(acc.listaSucursales || []).map((c: any) => <option key={c?.CompCod} value={c?.CompCod}>{c?.CompNom}</option>)}
                </select>
            </div>
            <div className="tw-flex tw-flex-col sm:tw-flex-row sm:tw-items-center tw-gap-1 sm:tw-gap-3">
                <label htmlFor="simple-sedes" className="tw-m-0 tw-shrink-0 sm:tw-w-28 tw-text-sm tw-font-medium tw-text-gray-700">Sede</label>
                <div className="tw-min-w-0 tw-flex-1">
                    <Select
                        inputId="simple-sedes"
                        isMulti
                        options={acc.listaSedes?.map((e: any) => ({ value: e?.SedCod, label: e?.SedDesc })) || []}
                        value={simple.sedes}
                        onChange={(seleccion) => simple.setSedes([...(seleccion || [])])}
                        placeholder="Seleccione una o varias sedes"
                        noOptionsMessage={() => "Sin sedes disponibles"}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        menuPlacement="auto"
                    />
                </div>
            </div>
            <p className="tw-m-0 tw-text-xs tw-text-gray-500 sm:tw-pl-[7.75rem]">La primera sede es la principal del usuario.</p>
            {otras > 0 &&
                <div className="tw-flex tw-flex-col sm:tw-flex-row sm:tw-items-center tw-gap-2">
                    <div className="tw-flex-1"><Aviso tono="alerta" texto={`${otras} sede(s) no son de la sucursal elegida. Se permite como hasta hoy; para definir exactamente qué ve por sucursal, use "Por organización".`} /></div>
                    <button type="button" className="btn btn-sm btn-secundario tw-shrink-0" onClick={() => acc.cambiarModo("organizacion")}>Usar Por organización</button>
                </div>}
        </section>
    )
}
